import * as React from 'react';
import { SVGProps } from 'react';

const IconSelectOpenSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 3.5 10 8H2l4-4.5Z" />
  </svg>
);
export default IconSelectOpenSizeXs;
